import { render, staticRenderFns } from "./pin-detail.vue?vue&type=template&id=3a92122f&"
import script from "./pin-detail.js?vue&type=script&lang=js&"
export * from "./pin-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports